﻿import { _, locale, init, register } from 'svelte-i18n';

const supportedLocales = ['nl', 'en'] as const;

export function setLocale(newLocale) {
    locale.set(newLocale);
    localStorage.setItem('locale', newLocale);
}

function getInitialLocale() {
    if(localStorage.getItem('locale'))
        return localStorage.getItem('locale');
    
    const browserLocales = window.navigator.languages ?? [window.navigator.language];
    for (const locale of browserLocales) {
        const language = locale.split('-')[0];

        if (supportedLocales.includes(language as typeof supportedLocales[number])) {
            return language;
        }
    }

    return 'en';
}

register('en', () => import('./locales/en.json'));
register('nl', () => import('./locales/nl.json'));

init({
    fallbackLocale: 'en',
    initialLocale: getInitialLocale(),
});